import { Injectable } from '@angular/core';
import { EloquaInteraction } from '../../models/appstats/appstats-eloqua.model';
import { EloquaInteractionResult } from '../../components/app-report/models/appstats-report.model';

@Injectable({
    providedIn: 'root',
})
export class SyncLogMergeService {
    public mergeSyncLogData(
        syncLogDataArray: Array<EloquaInteraction[]>,
        syncLogInteractionsRequestMap: Map<string, string>
    ): EloquaInteractionResult[] {
        const newEloquaInteractionsResultsList: EloquaInteractionResult[] = [];
        if (syncLogDataArray.length) {
            syncLogDataArray.forEach(syncLogData => {
                const interactionsResult = new EloquaInteractionResult();
                interactionsResult.items = [];
                syncLogData.forEach(interaction => {
                    if (interaction.eloquaImportId) {
                        interactionsResult.type = syncLogInteractionsRequestMap.get(interaction.eloquaImportId);
                    } else if (interaction.eloquaExportId) {
                        interactionsResult.type = syncLogInteractionsRequestMap.get(interaction.eloquaExportId);
                    }
                    const existingInteractionType = newEloquaInteractionsResultsList.find(
                        interaction => interaction.type === interactionsResult.type
                    );
                    if (existingInteractionType) {
                        existingInteractionType.items!.push(interaction);
                    } else {
                        interactionsResult.items!.push(interaction);
                        newEloquaInteractionsResultsList.push(interactionsResult);
                    }
                });
            });
        }
        return newEloquaInteractionsResultsList;
    }
}
